import Vue from 'vue';
import AdminTable from '@/components/AdminTable';
import ImageBox from '@/components/ImageBox';
import Uploader from '@/components/Uploader';
import Window from '@/components/Window';
import SearchBox from '@/components/SearchBox';
import FileUploader from '@/components/FileUploader';
import EmptyPage from '@/components/EmptyPage';

Vue.component('AdminTable', AdminTable);
Vue.component('ImageBox', ImageBox);
Vue.component('Uploader', Uploader);
Vue.component('Window', Window);
Vue.component('SearchBox', SearchBox);
Vue.component('FileUploader', FileUploader);
Vue.component('EmptyPage', EmptyPage);



// WEBPACK FOOTER //
// ./src/plugins/globalComponents.js